import { server } from '../constants';
import { httpClient } from '../utils/HttpClient';

/*________________________
 *  Permission Level Data 
 *========================
 */

/**
 * getListAllSetting()
 * @param {object} params
 * @param {object} params.lang Default: TH
 * @returns
 * Detail: Get all permission level except level 0 for setting page
 * API Doc: /muit-iDev/pdpa-im-api/-/wikis/Master/PermissionLevel
 */
export function getListAllSetting(params = { lang: 'TH' }) {
  return httpClient
    .get(`${server.PERMISSION_LEVEL_URL}/getListAllSetting/${params.lang}`)
    .then((result) => {
      return result.data.content;
    })
    .catch((error) => {
      throw error;
    });
}


/*________________________
 *  Permission Level Data form Admin
 *========================
 */

/**
 * getListAllWithUserRight()
 * @param {object} params
 * @param {object} params.lang Default: TH
 * @returns
 * Detail: Get all permission level except level 0 for setting page
 * API Doc: /muit-iDev/pdpa-im-api/-/wikis/Master/PermissionLevel
 */
 export function getListAllWithUserRight(params = { lang: 'TH' }) {
  return httpClient
    .get(`${server.PERMISSION_LEVEL_URL}/getListAllWithUserRight/${params.lang}`)
    .then((result) => {
      return result.data.content;
    })
    .catch((error) => {
      throw error;
    });
}
